import { createContext, useContext } from 'react';
import Logger from 'src/utils/logger.utils';
export var Chain;
(function (Chain) {
    Chain["STEEM"] = "STEEM";
    Chain["EVM"] = "EVM";
})(Chain || (Chain = {}));
export const ChainContext = createContext({
    chain: undefined,
    setChain: (chain) => Logger.log('no chain provider'),
});
export const useChainContext = () => useContext(ChainContext);
